/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import React from 'react';
import {DropdownMenu, Flex} from '@radix-ui/themes';
import {useTheme, THEMES} from '../../../../contexts/ThemeContext';
import UIStrings from '../../constants/UIStrings';
import ThemeIcon from './ThemeIcon';

const THEME_ORDER = [THEMES.LIGHT, THEMES.DARK, THEMES.SYSTEM];

/**
 * Light / Dark / System radio items for a dropdown menu. Reads and saves the theme
 * preference itself, so the header switcher and the user menu stay in step.
 * Must be rendered inside a DropdownMenu Content or SubContent.
 *
 * @param {Object} props
 * @param {string} props.testIdPrefix - each item gets data-testid="<prefix>-<theme>"
 * @param {string} props.analyticsIdPrefix - each item gets data-analytics-id="<prefix>-<theme>"
 */
export default function ThemeRadioGroup({testIdPrefix, analyticsIdPrefix}) {
  const {themePreference, setThemePreference} = useTheme();

  return (
    <DropdownMenu.RadioGroup value={themePreference} onValueChange={setThemePreference}>
      {THEME_ORDER.map((value) => (
        <DropdownMenu.RadioItem
          key={value}
          value={value}
          data-testid={`${testIdPrefix}-${value}`}
          data-analytics-id={`${analyticsIdPrefix}-${value}`}
        >
          <Flex align="center" gap="3">
            <ThemeIcon theme={value} />
            {UIStrings.THEME.OPTION[value]}
          </Flex>
        </DropdownMenu.RadioItem>
      ))}
    </DropdownMenu.RadioGroup>
  );
}
